import React, { useEffect, useState } from "react";
import MainLayout from "../Layout/MainLayout";
import Box from "@mui/material/Box";
import CloseIcon from '@mui/icons-material/Close';
import SearchIcon from '@mui/icons-material/Search';
import { styled } from "@mui/material/styles";
import { Button } from "@mui/material";
import ReactPaginate from "react-paginate";
import loadingScreen from '../../assets/img/loader4.gif'
import ReportGenerate from "../Layout/ReportGenerate";
import TextAlignment from "../Layout/TextAliginment";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import { AuthenticatedTemplate, UnauthenticatedTemplate } from "@azure/msal-react";
import Login from "../auth/Login";

const DrawerHeader = styled("div")(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "flex-start",
  padding: theme.spacing(2, 0),
  // necessary for content to be below app bar
  ...theme.mixins.toolbar,
}));

const Feedback = () => {
  const [query, setQuery] = useState("");
  const [filterByFeedback, setFilterByFeedback] = useState("");
  const [currentPagelimit, setPageLimit] = useState(20);
  const [currentPage, setCurrentPage] = useState(1);
  const [PageLoad, setPageLoad] = useState(true);

  const [data, setdata] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [paginatedData, setPaginatedData] = useState([]);
  const [feedbackNumber, setFeedbackNumber] = useState(null);
  const [openDialog, setOpenDialog] = useState(false);
  const [filteredResponseTxt, setFilteredResponseTxt] = useState('');

  const baseurl = `${process.env.REACT_APP_BASE_URL}/ai/feedback`;

  useEffect(() => {
    GetSaveReports();
  }, [baseurl]);

  useEffect(() => {
    // Update paginated data whenever data or currentPage changes
    const startIndex = (currentPage - 1) * currentPagelimit;
    const endIndex = startIndex + currentPagelimit;
    setPaginatedData(filteredData.slice(startIndex, endIndex));
  }, [filteredData, currentPage, currentPagelimit]);

  const GetSaveReports = async () => {
    const header = {
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json', // Add header to accept JSON
      }
    }
    try {
      const response = await fetch(baseurl, header);

      if (response.ok) {
        setPageLoad(false)
        const jsonData = await response.json();
        setdata(jsonData);
        setFilteredData(jsonData); // Update filteredData after fetching data
      } else {
        setdata([]);
        setPageLoad(false);
      }
    } catch (err) {
      console.error("Error:", err);
      setdata([]);
      setPageLoad(false);
    }
  };

  const handlePageChange = ({ selected }) => {
    setCurrentPage(selected + 1);
  };

  const searchParameters = ["email", "question", "commentText", "responseText"];

  useEffect(() => {
    // Update filteredData whenever query or filterByFeedback changes
    const filteredData = data.filter((item) => {
      return (
        searchParameters.some(
          (parameter) =>
            item[parameter] &&
            item[parameter].toString().toLowerCase().includes(query.toLowerCase())
        ) &&
        (filterByFeedback === "" || item.feedback.toString() === filterByFeedback)
      );
    });

    const extractTime = function (time) {
      const date = new Date(time);
      const months = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
      const year = date.getFullYear();
      const monthIndex = date.getMonth();
      const month = months[monthIndex];
      const day = date.getDate();
      let hours = date.getHours();
      const minutes = date.getMinutes();
      const amPM = hours >= 12 ? 'PM' : 'AM';
      hours = hours % 12 || 12;
      const feedbackDate = month + " " + day + ", " + year;
      const feedbackTime = hours + ":" + (minutes < 10 ? '0' : '') + minutes + ' ' + amPM;
      return { feedbackDate: feedbackDate, feedbackTime: feedbackTime }
    }

    let badFeedback = 0;
    let goodFeedback = 0;

    const newArray = filteredData.map((item) => {
      const { feedbackDate, feedbackTime } = extractTime(item.createdAt);
      if (item.feedback === -1) {
        badFeedback++;
      } else {
        goodFeedback++;
      }
      const strArr = item.commentText.split(',')
      const extraComment = strArr[0];
      strArr.shift();
      const strArr1 = strArr.join(',').split(':');
      strArr1.shift();
      let firstComment = '';
      if (strArr1[0].includes('Anything else')) {
        firstComment = strArr1.shift();
      }
      const strArr2 = strArr1.join(', ').split(',');
      if (firstComment) {
        strArr2.unshift(firstComment);
      }
      return { ...item, mainComment: strArr2, extraComment: extraComment, feedbackDate, feedbackTime }
    })
    setFilteredData(newArray);
    setCurrentPage(1);
    setFeedbackNumber(prevState => {
      return { ...prevState, badFeedback, goodFeedback }
    })
  }, [data, query, filterByFeedback]);

  const resetAll = () => {
    setCurrentPage(1);
    setQuery("");
    setFilterByFeedback("");
  };

  const pageCount = Math.ceil(filteredData.length / currentPagelimit);
  const filter_feedback = ["1", "-1"];

  const handelepageclick = (data) => {
    setCurrentPage(data.selected + 1);
  };

  const dialogHandler = (id) => {
    const filteredResponse = paginatedData.filter(item => item.feedbackId === id);
    setFilteredResponseTxt(prevState => filteredResponse[0].responseText);
    setOpenDialog(true);
  }

  return (
    <>

      <AuthenticatedTemplate>
        <div id="homePage" className="feedback-main-page">
          <Box className="mainLayout" sx={{ display: "flex", overflow: "hidden" }}>
            <MainLayout />

            <Box component="main" sx={{ flexGrow: 1, p: 1 }}>
              <DrawerHeader />
              <DrawerHeader style={{ minHeight: "0px", paddingTop: "3px" }} />

              <div id="mainHome" className={`feedback-main-container`}>
                {PageLoad && (
                  <>
                    <div className="loadingScreenCls">
                      <span>
                        <img
                          style={{ width: "80px" }}
                          src={loadingScreen}
                          alt="logo"
                        />
                      </span>
                    </div>
                  </>
                )}

                {!PageLoad && (
                  <>
                    <span style={{ paddingTop: "1rem", paddingLeft: '12px', fontSize: "28px", fontWeight: "600", display: "block", color: "#999" }}>Feedback Overview</span>
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        padding: "0px 12px",
                        flexWrap: "wrap",
                        gridGap: "10px",
                        marginTop: "32px",
                      }}
                      className={`${(filterByFeedback.toString() === '1' || filterByFeedback.toString() === '-1') ? 'margin-top-cls' : ''}`}
                    >
                      <div
                        className="search-wrapper"
                        style={{ width: "40%", alignSelf: "center", position: "relative" }}
                      >
                        <input
                          type="search"
                          name="search-form"
                          id="search-form"
                          value={query}
                          className="SearchBox_newworkflow"
                          placeholder="Search for comments"
                          autoComplete="off"
                          onChange={(e) => {
                            setQuery(e.target.value);
                            handlePageChange({ selected: 1 });
                          }}
                        />
                        <SearchIcon className="search-icon" />
                      </div>
                      <div
                        style={{
                          display: "flex",
                          width: "33%",
                          gridGap: "20px",
                          justifyContent: "flex-end",
                        }}
                      >
                        <div>
                          <ReportGenerate
                            excelData={filteredData}
                            fileName={`Feedback_${new Date().getTime()}`}
                          />
                        </div>
                        <div className="selectParent select">
                          <select
                            value={filterByFeedback}
                            onChange={(e) => {
                              setFilterByFeedback(e.target.value);
                              handlePageChange({ selected: 1 });
                            }}
                            className="custom-select custom-selectworkflow"
                            aria-label="Filter Feedback"
                          >
                            <option value="">Filter By Feedback</option>
                            {filter_feedback.map((item, index) => (
                              <option key={index} value={item}>
                                {item === "-1" ? "Bad" : "Good"}
                              </option>
                            ))}
                          </select>
                          <span className="focus"></span>
                        </div>

                        <Button
                          style={{
                            background: "#0000a0",
                            border: "none",
                            outline: "none",
                            color: "white",
                            height: "95%",
                            padding: "8px 12px",
                            borderRadius: "6px",
                          }}
                          onClick={resetAll}
                        >
                          Reset
                        </Button>
                      </div>
                    </div>
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        paddingBottom: "0rem",
                        paddingTop: "2rem",
                        paddingLeft: "12px",
                        paddingRight: "12px"
                      }}
                    >


                      <div className="feedback-length">
                        <p className="feedback-length-text">Total Number of Feedbacks: <span>{paginatedData.length}</span></p>
                      </div>

                      <div
                        style={{
                          display: "flex",
                          gridGap: "10px",
                          alignItems: "center",
                          alignContent: "center",
                          alignSelf: 'flex-end'
                        }}
                      >
                        <div>
                          <ReactPaginate
                            previousLabel={"Previous"}
                            nextLabel={"Next"}
                            breakLabel={"..."}
                            pageCount={pageCount}
                            marginPagesDisplayed={2}
                            pageRangeDisplayed={3}
                            onPageChange={handelepageclick}
                            containerClassName={"pagination"}
                            pageClassName={"page-item"}
                            pageLinkClassName={"page-link"}
                            previousClassName={"page-item"}
                            previousLinkClassName={"page-link"}
                            nextClassName={"page-item"}
                            nextLinkClassName={"page-link"}
                            breakClassName={"page-item"}
                            breakLinkClassName={"page-link"}
                            activeClassName={"active"}
                            forcePage={currentPage - 1}
                          />
                        </div>
                      </div>

                    </div>

                    <div
                      style={{
                        gridGap: "10px",
                        justifyContent: "flex-start",
                        width: "100%",
                        textAlign: "left",
                        overflow: "hidden",
                        overflowY: "auto",
                        height: "65%",
                      }}
                      className="feedback-table-main"
                    >
                      <div
                        style={{
                          color: "white",
                          height: "400px",
                          overflow: "hidden",
                          overflowY: "auto",
                        }}
                        className="feedback-table-container"
                      >
                        <div
                          style={{ color: "#999" }}
                          className="feedback-table-box"
                        >
                          {paginatedData.length > 0 && (
                            <table
                              id="tableId"
                              style={{ width: "100%" }}
                              className="feedback-table"
                            >
                              <thead>
                                <tr>
                                  <th
                                    className="header-column"
                                    style={{ width: "8%" }}
                                  >
                                    Email
                                  </th>
                                  <th
                                    className="header-column"
                                    style={{ width: "18%" }}
                                  >
                                    Questions
                                  </th>
                                  <th
                                    className="header-column"
                                    style={{ width: "30%" }}
                                  >
                                    Response
                                  </th>
                                  <th
                                    className="header-column"
                                    style={{ width: "7%" }}
                                  >
                                    Feedback
                                  </th>
                                  <th
                                    className="header-column"
                                    style={{ width: "25%" }}
                                  >
                                    Queries
                                  </th>
                                  <th
                                    className="header-column"
                                    style={{ width: "12%" }}
                                  >
                                    Date & Time
                                  </th>
                                </tr>
                              </thead>
                              <tbody>
                                {paginatedData.map((item) => (
                                  <>
                                    <tr key={item.id}>
                                      <td className="cell-border">
                                        {" "}
                                        <span className="email-column email-text">
                                          {item.email}
                                        </span>
                                      </td>
                                      <td
                                        style={{ textAlign: "center" }}
                                        className="cell-border"
                                      >
                                        <span
                                          className={`${!item.question ? "email-column" : ""
                                            }`}
                                        >
                                          {item.question ? item.question : "N/A"}
                                        </span>
                                      </td>
                                      <td className="cell-border response-text">
                                        <p className="response-text-para">
                                          {item.responseText}
                                        </p>{" "}
                                        <span
                                          className="see-more-btn"
                                          onClick={() =>
                                            dialogHandler(item.feedbackId)
                                          }
                                        >
                                          See More
                                        </span>
                                      </td>

                                      <td
                                        style={{ textAlign: "center" }}
                                        className="cell-border"
                                      >
                                        <span
                                          className={`email-column ${item.feedback === -1
                                              ? "color-red"
                                              : "color-green"
                                            }`}
                                        >
                                          {item.feedback === -1 ? "Bad" : "Good"}
                                        </span>
                                      </td>
                                      <td className="cell-border">
                                        <div className="comment-box">
                                          <p className={`extra-comments-text`}>
                                            {item.extraComment
                                              ? item.extraComment
                                              : ""}
                                          </p>
                                          <div className="main-comment">
                                            <p className="extra-comment-heading">
                                              Additional Comments are:{" "}
                                            </p>
                                            {Array.isArray(item.mainComment) &&
                                              item.mainComment.map(
                                                (comment) =>
                                                  comment && (
                                                    <p className="email-column main-comment-text">
                                                      {comment}
                                                    </p>
                                                  )
                                              )}
                                          </div>
                                        </div>
                                      </td>
                                      <td className="cell-border">
                                        {" "}
                                        <span className="feedback-time">
                                          {item.feedbackDate}
                                        </span>{" "}
                                        <span className="feedback-time">
                                          {item.feedbackTime}
                                        </span>
                                      </td>
                                    </tr>
                                  </>
                                ))}
                              </tbody>
                            </table>
                          )}
                          {paginatedData && paginatedData.length === 0 && (
                            <p className="no-feedback-msg">
                              No Feedback Available...
                            </p>
                          )}
                        </div>
                      </div>
                    </div>
                  </>
                )}
              </div>
            </Box>
          </Box>
          <Dialog
            open={openDialog}
            onClose={() => {
              setOpenDialog(false);
            }}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
            id="response-pop-up"
          >
            <DialogTitle id="alert-dialog-title">{"Response"}</DialogTitle>
            <DialogContent className="response-text-container">
              <DialogContentText id="alert-dialog-description">
                <TextAlignment text={filteredResponseTxt} />
              </DialogContentText>
            </DialogContent>
            <DialogActions className="dialog-action-cross">
              <Button
                onClick={() => {
                  setOpenDialog(false);
                }}
              >
                <CloseIcon className="close-icon" />
              </Button>
            </DialogActions>
          </Dialog>
        </div>
      </AuthenticatedTemplate>

      <UnauthenticatedTemplate>
        <Login />
      </UnauthenticatedTemplate>
    </>
  );
};

export default Feedback;
